import Filters from '@wwdev/product/filters';
import SearchRequest from '@wwdev/product/SearchRequest';

class CustomFilters extends Filters {
	constructor(config) {
		super(Object.assign({
			types: '[data-scope="types"]',
		}, config));
	}

	initEventListeners() {
		super.initEventListeners();
		$(this.config.filters).on('click.product', '[data-remove-filter]', this.removeFilter.bind(this))
		$(this.config.types).off('.product')
			.on('click.product', '[data-filter]', this.handleFilterClick.bind(this))
	}

	removeFilter(e) {
		e.preventDefault();
		let $button = $(e.currentTarget);
		this._removeFilter($button.data('tree-id'), $button.data('remove-filter'));
	}

	_removeFilter(treeId, filterId) {
		SearchRequest.clearFilter(treeId, filterId);
		this.reload();
	}
}

export default CustomFilters;